exports = module.exports = require("../../../apps/support-agent/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* History Screen */\n\n.historyContainer{\n\twidth:100%;\n\tposition:absolute;\n\tbottom:0;\n\ttop: 0;\n}\n#testHistoryContainer{\n\twidth:100%;\n\theight:70%;\n\tfloat:left;\n}\n", ""]);
